import React, { useState } from 'react'

import Web3 from 'web3'
import { toast } from 'react-toastify'

import { WalletButton } from '../wallet/WalletButton'
import { MintingInfo } from '../info/MintingInfo'
import styles from './Banner.module.scss'

export const Banner = () => {
    return (
        <div className={styles.banner}>
            <div className={styles.bg_blur}>
            </div>

            <div className={styles.top_container}>
                <a href='/'>
                    <div className={styles.logo}>
                    </div>
                </a>
                <WalletButton />
            </div>
            <div className={styles.middle_container}>
                <div className={styles.nft_info_container}>
                    <div className={styles.nft_image}>
                    </div>
                    <div className={styles.nft_contents_container}>
                        <span className={styles.nft_contents_title}>Code4Chain NFT ?</span>
                        <span className={styles.nft_contents_text}>Code4Chain의 Minting page 및 Market place등 다양한 솔루션을 체험해 보기 위해 발행 된 테스트 NFT입니다.<br /><br />* Opensea<br /> <a href="https://testnets.opensea.io/collection/code4chainnft" target="_blank">testnets.opensea.io/collection/code4chainnft</a></span>
                        <span className={styles.nft_contents_head}>Minting info</span>
                        <span className={styles.nft_contents_text}>해당 민팅페이지는 지갑연결을 폴리곤 테스트넷 Mumbai로 연결될 수 있게 세팅되어 있습니다. 실제 민팅을 테스트 해보기 위해서는 아래와 같은 작업을 사전에 진행하셔야 합니다.<br /><br />1. <a href="https://chainlist.org/" target="_blank">https://chainlist.org/</a>에서 검색창 옆에 Testnets 버튼 활성화 후 Mumbai 검색해서 본인의 메타마스크에 Mumbai 네트워크 추가<br /><br />2. <a href="https://faucet.polygon.technology/" target="_blank">https://faucet.polygon.technology/</a>에서 본인의 메타마스크 지갑주소를 입력 후 Mumbai 체인 Matic 에어드랍 받기<br /><br />* 실제 민팅 제작은 클라이언트 요청에 따라 이더리움, 폴리곤, 클레이튼, 솔라나 등 다양하게 제작이 가능합니다.</span>
                    </div>
                </div>
                <MintingInfo />
            </div>
            <div className={styles.bottom_container}>
            </div>
        </div>
    )
}